<template>
  <div>
    <div v-show="$store.state.isShowTop">
      <img
        src="../../../public/sticker/atbotton.png"
        class="horizontal-center-image top"
        alt="可可爱爱"
      />
      <!--      todo:支付宝年账单-->
    </div>

    <img
      src="../../../public/sticker/main.png"
      class="center-image"
      alt="hduhelper"
    />

    <div v-show="$store.state.isShowBottom">
      <img
        src="../../../public/sticker/upsidedown.png"
        class="horizontal-center-image button"
        alt="hduhelper"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'background',
  mounted() {},
}
</script>

<style scoped>
.horizontal-center-image.top {
  height: 20vh;
  transform: scaleY(-1);
  top: -0.5vh;
}

.horizontal-center-image.button {
  top: 80vh;
  height: 20vh;
}

.center-image {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  height: 30vh;
}

.horizontal-center-image {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0 auto;
  height: 30vh;
}
</style>
